import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main,
  },
  content: {
    // Adicione estilos para o conteúdo do diálogo, se necessário
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
}))
